import React, { useState } from "react";
import AuthTextInput from "../../components/common/commonTextInputs/authTextInput";
import bgImg from "../../assets/images/bgImg.png";
import brandLogo from "../../assets/logos/brandLogo.svg";
import AuthButton from "../../components/common/commonButtons/authButton";
import { useNavigate, useParams } from "react-router-dom";
import CommonSnackbar from "../../components/common/toastMessage";
import { ForgoPasswordChangeAPI } from "../../services/authServices";
interface ChangePasswordState {
  password: string;
  confirmPassword: string;
  errors: {
    passwordError: string;
    confirmPasswordError: string;
    validationError: string;
  };
}
const SettingPassword: React.FC = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [changePassword, setChangePassword] = useState<ChangePasswordState>({
    password: "",
    confirmPassword: "",
    errors: {
      passwordError: "",
      confirmPasswordError: "",
      validationError: "",
    },
  });
      const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        color: "green",
      });
  const [error, setErrors] = useState<any>({
    wholeError: false,
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = { passwordError: "", confirmPasswordError: "" };

    if (changePassword.password.length < 8) {
      newErrors.passwordError = "Password must be at least 8 characters.";
      isValid = false;
    }

    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])[A-Za-z\d!\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/.test(
        changePassword.password
      )
    ) {
      newErrors.passwordError =
        "Password must contain at least 1 uppercase letter, 1 number, and 1 special character.";
      isValid = false;
    }

    if (changePassword.password !== changePassword.confirmPassword) {
      newErrors.confirmPasswordError = "Passwords do not match.";
      isValid = false;
    }

    setChangePassword((prev: any) => ({ ...prev, errors: newErrors }));
    return isValid;
  };

  // Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setChangePassword((prev: any) => ({
      ...prev,
      [name]: value,
      errors: { ...prev.errors, [`${name}Error`]: "" },
    }));
  };

  const handleSubmit = async() => {
    console.log("change password submit ");
    
    if (!validateForm()) return; 

    let payload = {
      newPassword: changePassword.password,
      confirmPassword: changePassword.confirmPassword,
  };
  // console.log(payload,"payload>>>");
  try {
      setLoading(true);
      const response = await ForgoPasswordChangeAPI(token,payload);
      if (response) {
          // If no errors, proceed
          setSnackbar({
            open: true,
            message: "Password Changed SuccessFully!!!",
            color: "green",
          });
          setTimeout(() => {
              navigate("/admin/login");
          }, 1000);
      } else {
        setSnackbar({
          open: true,
          message: "Incorrect Password",
          color: "red",
        });
      }
  } catch (error: any) {
      console.log(error.message || "Something went wrong");
  } finally {
      setLoading(false);
  }
  }
  return (
    <>
      <div
        className="flex justify-center items-center w-[100%] h-screen bg-cover bg-center text-white"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="!w-[400px] flex justify-center items-center bg-authContainerBg border border-authContainerBg !rounded-2xl">
          <div className="!m-[1rem] w-[75%] flex flex-col justify-center items-center !my-[2rem]" >
            <img src={brandLogo} alt="Awesome-Logo" className="!mb-[0.5rem]" />
            <p className="font-bold text-[1.3rem]">Reset Password !</p>
            <p className="text-[0.7rem] ">Create New Password</p>
            <AuthTextInput placeholder="Enter New Password" types="password"
                    name="password"
                    value={changePassword.password}
                    onChange={handleChange} />
                     {changePassword.password.length < 8 ? (
                    <span className="text-[0.8rem] text-red-500 ">
                      {changePassword.errors.passwordError}
                    </span>
                  ) : (
                    changePassword.errors.passwordError && (
                      <span className="text-[0.8rem] text-red-500 ">
                        {changePassword.errors.passwordError}
                      </span>
                    )
                  )}
            <AuthTextInput placeholder="Confirm New Password"  types="password"
                    name="confirmPassword"
                    value={changePassword.confirmPassword}
                    onChange={handleChange} />
 {changePassword.password !==
                    changePassword.confirmPassword && (
                    <span className="text-[0.8rem] text-red-500">
                      {changePassword.errors.confirmPasswordError}
                    </span>
                  )}
                  {error.wholeError && (
                    <span className="text-[0.8rem] text-red-500">
                      {changePassword.errors.validationError}
                    </span>
                  )}
            <AuthButton
              message="Continue" onClick={handleSubmit}
              classes="bg-gradient-to-r from-[#3BEBAA4D] to-[#3983DD] !font-bold !text-[0.7rem] !normal-case !text-white w-[100%] !rounded-[5px] h-[2.3rem] !p-[0.9rem] !mt-[1rem]"
            />
          </div>
        </div>
        <CommonSnackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        backgroundColor={snackbar.color}
      />
      </div>
    </>
  );
};

export default SettingPassword;
